// Mock data for the work agency website

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      jobs: "Jobs",
      testimonials: "Success Stories",
      contact: "Contact"
    },
    hero: {
      title: "Your Gateway to Work in Europe",
      subtitle: "Connecting Albanian talent with German opportunities",
      cta1: "Find Jobs",
      cta2: "Apply Now"
    },
    about: {
      title: "About Our Agency",
      description: "We are a leading work agency specializing in connecting skilled Albanian workers with premium employment opportunities in Europe. We handle everything from job matching to visa assistance and relocation support, ensuring a smooth transition to your new career in Europe."
    },
    services: {
      title: "Our Services",
      items: [
        {
          title: "Job Placement",
          description: "We connect you with quality employers in Europe based on your skills and experience"
        },
        {
          title: "German Language Course",
          description: "Comprehensive German language training to prepare you for life and work in Europe"
        },
        {
          title: "Visa Assistance",
          description: "Complete support for work permits and visa applications from start to finish"
        },
        {
          title: "Support Until Arrival",
          description: "Full assistance and guidance from application through your safe arrival in Europe"
        },
        {
          title: "Accommodation Help",
          description: "Support in finding suitable housing and settling in your new German city"
        },
        {
          title: "Legal Guidance",
          description: "Clear advice on employment contracts, workers rights, and legal obligations"
        }
      ]
    },
    jobs: {
      title: "Available Positions",
      location: "Location",
      salary: "Salary",
      type: "Type",
      apply: "Apply Now"
    },
    application: {
      title: "Apply for Work in Europe",
      subtitle: "Fill out the form below and we'll get back to you within 24 hours",
      fullName: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      position: "Position Interested In",
      experience: "Years of Experience",
      message: "Additional Information",
      submit: "Submit Application",
      success: "Application submitted successfully!",
      error: "Failed to submit application. Please try again."
    },
    testimonials: {
      title: "Success Stories"
    },
    contact: {
      title: "Contact Us",
      subtitle: "Have questions? Get in touch with us",
      address: "Address",
      phone: "Phone",
      email: "Email",
      send: "Send Message"
    },
    footer: {
      about: "About",
      aboutText: "Professional work agency connecting Albanian talent with German opportunities.",
      quickLinks: "Quick Links",
      contactInfo: "Contact Info",
      rights: "All rights reserved."
    }
  },
  de: {
    nav: {
      home: "Startseite",
      about: "Über uns",
      services: "Dienstleistungen",
      jobs: "Stellenangebote",
      testimonials: "Erfolgsgeschichten",
      contact: "Kontakt"
    },
    hero: {
      title: "Ihr Tor zur Arbeit in Europa",
      subtitle: "Verbindung albanischer Talente mit deutschen Möglichkeiten",
      cta1: "Jobs finden",
      cta2: "Jetzt bewerben"
    },
    about: {
      title: "Über unsere Agentur",
      description: "Wir sind eine führende Arbeitsvermittlung, die sich darauf spezialisiert hat, qualifizierte albanische Arbeitskräfte mit erstklassigen Beschäftigungsmöglichkeiten in Europa zu verbinden. Mit über 8 Jahren Erfahrung seit 2015 kümmern wir uns um alles, von der Jobvermittlung bis zur Visaunterstützung und Umzugshilfe. Wir haben erfolgreich über 2.500 albanische Arbeitskräfte in Qualitätspositionen in ganz Europa vermittelt."
    },
    services: {
      title: "Unsere Dienstleistungen",
      items: [
        {
          title: "Jobvermittlung",
          description: "Wir verbinden Sie mit Qualitätsarbeitgebern in Europa basierend auf Ihren Fähigkeiten"
        },
        {
          title: "Deutschkurs",
          description: "Umfassendes Deutschtraining, um Sie auf das Leben und Arbeiten in Europa vorzubereiten"
        },
        {
          title: "Visa-Unterstützung",
          description: "Vollständige Unterstützung bei Arbeitserlaubnis und Visaanträgen von Anfang bis Ende"
        },
        {
          title: "Unterstützung bis zur Ankunft",
          description: "Vollständige Hilfe und Anleitung von der Bewerbung bis zu Ihrer sicheren Ankunft in Europa"
        },
        {
          title: "Unterkunftshilfe",
          description: "Unterstützung bei der Suche nach geeignetem Wohnraum und Eingewöhnung in Ihrer neuen deutschen Stadt"
        },
        {
          title: "Rechtsberatung",
          description: "Klare Beratung zu Arbeitsverträgen, Arbeitnehmerrechten und rechtlichen Verpflichtungen"
        }
      ]
    },
    jobs: {
      title: "Verfügbare Stellen",
      location: "Standort",
      salary: "Gehalt",
      type: "Typ",
      apply: "Jetzt bewerben"
    },
    application: {
      title: "Bewerben Sie sich für Arbeit in Europa",
      subtitle: "Füllen Sie das Formular aus und wir melden uns innerhalb von 24 Stunden",
      fullName: "Vollständiger Name",
      email: "E-Mail-Adresse",
      phone: "Telefonnummer",
      position: "Gewünschte Position",
      experience: "Jahre Berufserfahrung",
      message: "Zusätzliche Informationen",
      submit: "Bewerbung absenden",
      success: "Bewerbung erfolgreich eingereicht!",
      error: "Fehler beim Einreichen. Bitte versuchen Sie es erneut."
    },
    testimonials: {
      title: "Erfolgsgeschichten"
    },
    contact: {
      title: "Kontaktieren Sie uns",
      subtitle: "Haben Sie Fragen? Kontaktieren Sie uns",
      address: "Adresse",
      phone: "Telefon",
      email: "E-Mail",
      send: "Nachricht senden"
    },
    footer: {
      about: "Über uns",
      aboutText: "Professionelle Arbeitsvermittlung, die albanische Talente mit deutschen Möglichkeiten verbindet.",
      quickLinks: "Schnelllinks",
      contactInfo: "Kontaktinformationen",
      rights: "Alle Rechte vorbehalten."
    }
  },
  sq: {
    nav: {
      home: "Ballina",
      about: "Rreth Nesh",
      services: "Shërbimet",
      jobs: "Punë",
      testimonials: "Histori Suksesi",
      contact: "Kontakt"
    },
    hero: {
      title: "Porta Juaj për Punë në Evropë",
      subtitle: "Duke lidhur talentin shqiptar me mundësitë gjermane",
      cta1: "Gjej Punë",
      cta2: "Apliko Tani"
    },
    about: {
      title: "Rreth Agjencisë Sonë",
      description: "Ne jemi një agjenci udhëheqëse e punës që specializohet në lidhjen e punonjësve të kualifikuar shqiptarë me mundësi punësimi premium në Evropë. Ne trajtojmë gjithçka nga përputhja e punës deri te ndihma për vizë dhe mbështetje për zhvendosje, duke siguruar një tranzicion të qetë në karrierën tuaj të re në Evropë."
    },
    services: {
      title: "Shërbimet Tona",
      items: [
        {
          title: "Vendosje Pune",
          description: "Ju lidhim me punëdhënës cilësorë në Evropë bazuar në aftësitë dhe përvojën tuaj"
        },
        {
          title: "Kurs i Gjuhës Gjermane",
          description: "Trajnim gjithëpërfshirës i gjuhës gjermane për t'ju përgatitur për jetën dhe punën në Evropë"
        },
        {
          title: "Ndihmë për Vizë",
          description: "Mbështetje e plotë për leje pune dhe aplikime për vizë nga fillimi deri në fund"
        },
        {
          title: "Mbështetje deri në Mbërritje",
          description: "Ndihmë dhe udhëzim i plotë nga aplikimi deri në mbërritjen tuaj të sigurt në Evropë"
        },
        {
          title: "Ndihmë për Strehim",
          description: "Mbështetje në gjetjen e strehimit të përshtatshëm dhe vendosje në qytetin tuaj të ri gjerman"
        },
        {
          title: "Udhëzim Ligjor",
          description: "Këshilla të qarta për kontratat e punës, të drejtat e punëtorëve dhe detyrimet ligjore"
        }
      ]
    },
    jobs: {
      title: "Pozicione të Disponueshme",
      location: "Vendndodhja",
      salary: "Paga",
      type: "Lloji",
      apply: "Apliko Tani"
    },
    application: {
      title: "Apliko për Punë në Evropë",
      subtitle: "Plotësoni formularin më poshtë dhe ne do t'ju kontaktojmë brenda 24 orëve",
      fullName: "Emri i Plotë",
      email: "Adresa e Email-it",
      phone: "Numri i Telefonit",
      position: "Pozicioni i Interesuar",
      experience: "Vite Përvojë",
      message: "Informacion Shtesë",
      submit: "Dërgo Aplikimin",
      success: "Aplikimi u dërgua me sukses!",
      error: "Dështoi dërgimi i aplikimit. Ju lutemi provoni përsëri."
    },
    testimonials: {
      title: "Histori Suksesi"
    },
    contact: {
      title: "Na Kontaktoni",
      subtitle: "Keni pyetje? Kontaktoni me ne",
      address: "Adresa",
      phone: "Telefoni",
      email: "Email",
      send: "Dërgo Mesazh"
    },
    footer: {
      about: "Rreth",
      aboutText: "Agjenci profesionale pune që lidh talentin shqiptar me mundësitë gjermane.",
      quickLinks: "Lidhje të Shpejta",
      contactInfo: "Informacion Kontakti",
      rights: "Të gjitha të drejtat e rezervuara."
    }
  }
};

export const mockJobs = [
  {
    id: 1,
    title: "Nurse - General Ward",
    titleDe: "Krankenpfleger/in - Allgemeinstation",
    titleSq: "Infermier/e - Pavion i Përgjithshëm",
    location: "Frankfurt, Hessen",
    salary: "€3,800 - €4,000/month",
    type: "Full-time",
    description: "Registered nurses needed for general ward in Frankfurt hospitals. EU certification required."
  },
  {
    id: 2,
    title: "Nurse - Intensive Care",
    titleDe: "Krankenpfleger/in - Intensivstation",
    titleSq: "Infermier/e - Kujdes Intensiv",
    location: "Frankfurt, Hessen",
    salary: "€3,800 - €4,000/month",
    type: "Full-time",
    description: "ICU nurses with experience for Frankfurt medical centers. Specialization in intensive care required."
  },
  {
    id: 3,
    title: "Nurse - Pediatrics",
    titleDe: "Krankenpfleger/in - Pädiatrie",
    titleSq: "Infermier/e - Pediatri",
    location: "Wiesbaden, Hessen",
    salary: "€3,800 - €4,000/month",
    type: "Full-time",
    description: "Pediatric nurses for children's hospitals in Hessen region. Experience with children preferred."
  },
  {
    id: 4,
    title: "Nurse - Emergency Department",
    titleDe: "Krankenpfleger/in - Notaufnahme",
    titleSq: "Infermier/e - Departamenti i Urgjencës",
    location: "Frankfurt, Hessen",
    salary: "€3,800 - €4,000/month",
    type: "Full-time",
    description: "Emergency room nurses for busy Frankfurt hospitals. Fast-paced environment, excellent benefits."
  },
  {
    id: 5,
    title: "Nurse - Geriatric Care",
    titleDe: "Krankenpfleger/in - Altenpflege",
    titleSq: "Infermier/e - Kujdes për të Moshuarit",
    location: "Darmstadt, Hessen",
    salary: "€3,800 - €4,000/month",
    type: "Full-time",
    description: "Geriatric nurses for senior care facilities in Hessen. Compassionate care for elderly patients."
  },
  {
    id: 6,
    title: "Nurse - Surgical Unit",
    titleDe: "Krankenpfleger/in - Chirurgische Station",
    titleSq: "Infermier/e - Njësia Kirurgjikale",
    location: "Frankfurt, Hessen",
    salary: "€3,800 - €4,000/month",
    type: "Full-time",
    description: "Surgical nurses for operating rooms and post-op care in Frankfurt hospitals. OR experience preferred."
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Ardit Krasniqi",
    position: "Construction Worker",
    location: "Berlin",
    year: "2016",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop",
    text: "This agency changed my life. Within 2 months, I was working in Berlin with a great salary and excellent working conditions. They helped me with everything from visa to finding accommodation.",
    textDe: "Diese Agentur hat mein Leben verändert. Innerhalb von 2 Monaten arbeitete ich in Berlin mit einem tollen Gehalt und ausgezeichneten Arbeitsbedingungen. Sie halfen mir bei allem, vom Visum bis zur Wohnungssuche.",
    textSq: "Kjo agjenci ndryshoi jetën time. Brenda 2 muajsh, po punoja në Berlin me një pagë të shkëlqyer dhe kushte të shkëlqyera pune. Më ndihmuan me gjithçka nga viza deri në gjetjen e strehimit."
  },
  {
    id: 2,
    name: "Erjona Hoxha",
    position: "Nurse",
    location: "Munich",
    year: "2017",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop",
    text: "Professional service from start to finish. They helped with everything - visa, housing, and language courses. Now I have a stable career in Munich hospital and brought my family here.",
    textDe: "Professioneller Service von Anfang bis Ende. Sie halfen bei allem - Visum, Unterkunft und Sprachkurse. Jetzt habe ich eine stabile Karriere im Münchner Krankenhaus und meine Familie hierher gebracht.",
    textSq: "Shërbim profesional nga fillimi deri në fund. Ata më ndihmuan me gjithçka - vizën, strehimin dhe kurset e gjuhës. Tani kam një karrierë të qëndrueshme në spitalin e Mynihut dhe kam sjellë familjen time këtu."
  },
  {
    id: 3,
    name: "Blerim Mustafa",
    position: "Electrician",
    location: "Stuttgart",
    year: "2018",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop",
    text: "Highly recommend! They found me a perfect position that matches my skills and the pay is excellent. After 5 years, I now have my own apartment and a car.",
    textDe: "Sehr empfehlenswert! Sie fanden mir eine perfekte Position, die meinen Fähigkeiten entspricht und die Bezahlung ist ausgezeichnet. Nach 5 Jahren habe ich jetzt meine eigene Wohnung und ein Auto.",
    textSq: "Rekomandoj shumë! Më gjetën një pozicion perfekt që përputhet me aftësitë e mia dhe paga është e shkëlqyer. Pas 5 vitesh, tani kam apartamentin tim dhe një makinë."
  },
  {
    id: 4,
    name: "Flamur Dervishi",
    position: "Warehouse Manager",
    location: "Frankfurt",
    year: "2019",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    text: "Started as a warehouse worker in 2019, now I'm a manager! Majestic Workforce helped me every step of the way. The German company values Albanian workers and I've been promoted twice.",
    textDe: "Begann 2019 als Lagerarbeiter, jetzt bin ich Manager! Majestic Workforce hat mir bei jedem Schritt geholfen. Das deutsche Unternehmen schätzt albanische Arbeiter und ich wurde zweimal befördert.",
    textSq: "Fillova si punëtor magazinë në 2019, tani jam menaxher! Majestic Workforce më ndihmoi në çdo hap. Kompania gjermane vlerëson punëtorët shqiptarë dhe jam promovuar dy herë."
  },
  {
    id: 5,
    name: "Anjeza Shehu",
    position: "Hotel Manager",
    location: "Hamburg",
    year: "2020",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop",
    text: "I was nervous about moving to Europe, but ATG made everything easy. They provided language training before I left Albania. Now I manage a 4-star hotel in Hamburg!",
    textDe: "Ich war nervös wegen des Umzugs nach Europa, aber ATG hat alles einfach gemacht. Sie boten Sprachtraining an, bevor ich Albanien verließ. Jetzt leite ich ein 4-Sterne-Hotel in Hamburg!",
    textSq: "Isha nervoz për t'u zhvendosur në Evropë, por ATG e bëri gjithçka të lehtë. Ata më dhanë trajnim gjuhësor përpara se të largoheshin nga Shqipëria. Tani drejtoj një hotel 4 yje në Hamburg!"
  },
  {
    id: 6,
    name: "Gentian Leka",
    position: "Chef",
    location: "Cologne",
    year: "2021",
    image: "https://images.unsplash.com/photo-1542909168-82c3e7fdca44?w=150&h=150&fit=crop",
    text: "Working in a Michelin-starred restaurant was my dream. ATG found me this opportunity and handled all paperwork. The salary is 3x what I earned in Albania. Thank you!",
    textDe: "In einem Michelin-Stern-Restaurant zu arbeiten war mein Traum. ATG fand mir diese Gelegenheit und kümmerte sich um alle Papiere. Das Gehalt ist 3x so hoch wie in Albanien. Vielen Dank!",
    textSq: "Puna në një restorant me yll Michelin ishte ëndrra ime. ATG më gjeti këtë mundësi dhe trajtoi të gjitha dokumentet. Paga është 3x sa fitoja në Shqipëri. Faleminderit!"
  },
  {
    id: 7,
    name: "Ermal Gashi",
    position: "Mechanic",
    location: "Düsseldorf",
    year: "2021",
    image: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=150&h=150&fit=crop",
    text: "Best decision of my life! Working for BMW now. The agency provided free German courses and helped my wife find a job too. We're building our future here.",
    textDe: "Beste Entscheidung meines Lebens! Arbeite jetzt für BMW. Die Agentur bot kostenlose Deutschkurse an und half meiner Frau auch, einen Job zu finden. Wir bauen hier unsere Zukunft auf.",
    textSq: "Vendimi më i mirë i jetës sime! Po punoj për BMW tani. Agjencia ofroi kurse gjermane falas dhe ndihmoi gruan time të gjejë punë gjithashtu. Po ndërtojmë të ardhmen tonë këtu."
  },
  {
    id: 8,
    name: "Klodiana Rama",
    position: "Accountant",
    location: "Leipzig",
    year: "2022",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop",
    text: "Professional and trustworthy agency. They matched me with a perfect accounting firm in Leipzig. I've already received a raise after one year. Highly professional team!",
    textDe: "Professionelle und vertrauenswürdige Agentur. Sie haben mich mit einer perfekten Wirtschaftsprüfungsgesellschaft in Leipzig zusammengebracht. Ich habe bereits nach einem Jahr eine Gehaltserhöhung erhalten. Hochprofessionelles Team!",
    textSq: "Agjenci profesionale dhe e besueshme. Më përputhën me një firmë kontabiliteti perfekte në Leipzig. Kam marrë tashmë një rritje page pas një viti. Ekip shumë profesional!"
  },
  {
    id: 9,
    name: "Elton Hyseni",
    position: "Software Developer",
    location: "Dresden",
    year: "2022",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150&h=150&fit=crop",
    text: "I thought IT jobs were impossible through agencies, but ATG proved me wrong! Now working for a tech startup in Dresden with excellent benefits and work-life balance.",
    textDe: "Ich dachte, IT-Jobs durch Agenturen seien unmöglich, aber ATG hat mich eines Besseren belehrt! Arbeite jetzt für ein Tech-Startup in Dresden mit ausgezeichneten Benefits und Work-Life-Balance.",
    textSq: "Mendova se punët në IT ishin të pamundura nëpërmjet agjencive, por ATG më provoi të gabuar! Tani punoj për një startup teknologjik në Dresden me përfitime të shkëlqyera dhe ekuilibër pune-jetë."
  },
  {
    id: 10,
    name: "Valdete Kola",
    position: "Physiotherapist",
    location: "Hannover",
    year: "2023",
    image: "https://images.unsplash.com/photo-1534751516642-a1af1ef26a56?w=150&h=150&fit=crop",
    text: "From Tirana to Hannover! ATG helped me get my qualifications recognized in Europe. Working in a private clinic now and earning more than I dreamed. Forever grateful!",
    textDe: "Von Tirana nach Hannover! ATG half mir, meine Qualifikationen in Europa anerkennen zu lassen. Arbeite jetzt in einer Privatklinik und verdiene mehr als ich träumte. Für immer dankbar!",
    textSq: "Nga Tirana në Hanover! ATG më ndihmoi të njoh kualifikimet e mia në Evropë. Po punoj në një klinikë private tani dhe fitoj më shumë sesa ëndërroja. Përgjithmonë mirënjohës!"
  },
  {
    id: 11,
    name: "Alban Hoxha",
    position: "Welder",
    location: "Dortmund",
    year: "2023",
    image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=150&h=150&fit=crop",
    text: "Excellent support throughout the process. They even helped me prepare for the job interview. Working in industrial welding now with great pay and benefits. Highly recommend ATG!",
    textDe: "Hervorragende Unterstützung während des gesamten Prozesses. Sie halfen mir sogar bei der Vorbereitung auf das Vorstellungsgespräch. Arbeite jetzt im Industrieschweißen mit toller Bezahlung und Benefits. ATG sehr zu empfehlen!",
    textSq: "Mbështetje e shkëlqyer gjatë gjithë procesit. Madje më ndihmuan të përgatitem për intervistën e punës. Po punoj në saldim industrial tani me pagë dhe përfitime të mira. Rekomandoj shumë ATG!"
  },
  {
    id: 12,
    name: "Mirela Çela",
    position: "Dental Hygienist",
    location: "Nuremberg",
    year: "2023",
    image: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=150&h=150&fit=crop",
    text: "Life-changing experience! From application to arrival, everything was handled professionally. Now working in a modern dental clinic in Nuremberg. My family is so proud!",
    textDe: "Lebensverändernde Erfahrung! Von der Bewerbung bis zur Ankunft wurde alles professionell abgewickelt. Arbeite jetzt in einer modernen Zahnklinik in Nürnberg. Meine Familie ist so stolz!",
    textSq: "Përvojë që ndryshoi jetën! Nga aplikimi deri te mbërritja, gjithçka u trajtua profesionalisht. Tani po punoj në një klinikë dentare moderne në Nuremberg. Familja ime është kaq krenare!"
  }
];

export const saveApplication = (data) => {
  // Mock function to save application locally
  const applications = JSON.parse(localStorage.getItem('applications') || '[]');
  applications.push({
    ...data,
    id: Date.now(),
    submittedAt: new Date().toISOString()
  });
  localStorage.setItem('applications', JSON.stringify(applications));
  return { success: true, id: Date.now() };
};
